export default __webpack_public_path__ + "img/5298c999aa308a1fe8c24b0866134378.svg";